<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="title"
        :primaryAction="{
            label: $t.__('common.actions.close'),
            action: () => (showModal = false),
        }"
        @closed="$emit('close')"
    >
        <template>
            <div v-html="message" class="typographies-paragraph-medium-regular" />
        </template>
    </CompassDialog>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showModal: true,
        };
    },
};
</script>
